import CryptoJS from 'crypto-js'

const getDecryptionKey = () => {
  let key = ''
  const incidents = 'CommonIncidents'
  key += incidents.charAt(13)
  key += incidents.charAt(1)
  key += incidents.charAt(2)
  key += 'brady'
  const number = 2 * 5
  key += (number / 2).toString()
  key += `r${incidents.toLowerCase().charAt(6)}${incidents.charAt(5)}gs`
  return key
}

export const decryptResponse = (responseData: any) => {
  const CryptoJSAesJson = {
    stringify: (cipherParams: any) => {
      const j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64), iv: undefined, s: undefined }
      if (cipherParams.iv) j.iv = cipherParams.iv.toString()
      if (cipherParams.salt) j.s = cipherParams.salt.toString()
      return JSON.stringify(j)
    },
    parse: (jsonStr: any) => {
      const j = JSON.parse(jsonStr)
      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(j.ct)
      })
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }

  const decrypted = JSON.parse(
    CryptoJS.AES.decrypt(JSON.stringify(responseData), getDecryptionKey(), {
      format: CryptoJSAesJson
    }).toString(CryptoJS.enc.Utf8)
  )
  return JSON.parse(decrypted)
}
